<template>
  <div>
    <v-card>
      <div class="pa-6">
        <CreateReviewForm :state="dialog" :exam="query.exam" @closeDialog="close" @refresh="refresh" />
        <v-card outlined>
          <div class="d-flex justify-end align-center">
            <v-spacer></v-spacer>
            <div class="d-flex justify-end align-center pr-6 pt-6">
              <v-btn color="primary" class="elevation-0" dark @click="openCreate">
                <v-icon left>mdi-plus</v-icon>Tạo đơn</v-btn
              >
            </div>
          </div>
          <v-data-table
            item-key="id"
            :headers="headers"
            :loading="loading"
            :items="students"
            :items-per-page="pagination.itemsPerPage"
            :page.sync="pagination.page"
            :server-items-length="pagination.totalItems"
            :disable-sort="$vuetify.breakpoint.smAndDown"
            :footer-props="{ 'items-per-page-text': 'Số đơn mỗi trang' }"
            :height="400"
            v-bind="this.$attrs"
            fixed-header
            @pagination="updatePagination"
          >
            <template v-slot:[`item.status`]="{ item }">
              {{ item | getStatus }}
            </template>
            <template v-slot:[`item.studentExam.examCode`]="{ item }">
              <a :href="`/exam-mark-review/${item.id}`" class="clickable-text">
                {{ item.studentExam.examCode }}
              </a>
            </template>
            <template v-slot:[`footer.page-text`]="items">
              Đơn thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} đơn
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import CreateReviewForm from './CreateReviewForm.vue'

const originHeaders = [
  {
    text: 'SBD',
    value: 'studentExam.examCode',
    align: 'left',
    sortable: false,
    width: '30%'
  },
  {
    text: 'Họ tên',
    value: 'student.name',
    align: 'left',
    sortable: false,
    width: '30%'
  },
  {
    text: 'Trạng thái',
    value: 'status',
    align: 'left',
    sortable: false,
    show: true,
    width: '30%'
  }
]

export default {
  props: {
    query: Object,
    subjects: Array,
    rooms: Array,
    type: String,
    grade: String
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      dialog: false,
      updateDialog: false,
      roomDialog: false,
      confirmDialog: false,
      dateDialog: false,
      showColumnSelector: false,
      singleDateDialog: false,
      selectedItems: [],
      selected: [],
      students: [],
      item: {},
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0
      }
    }
  },
  computed: {},
  methods: {
    ...mapActions('gradeReview', ['fetchGradeReviews', 'countGradeReviews']),
    async refresh() {
      this.$loading.active = true
      this.loading = true
      const start = (this.pagination.page - 1) * this.pagination.itemsPerPage
      const limit = this.pagination.itemsPerPage
      try {
        this.pagination.totalItems = await this.countGradeReviews(this.query)
        this.students = await this.fetchGradeReviews({
          _start: start,
          _limit: limit,
          ...this.query,
          _sort: 'index:asc'
        })
      } catch (error) {
        this.$alert.error('Lỗi load thông tin học sinh')
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },
    updatePagination(val) {
      this.pagination.page = val.page
      this.pagination.itemsPerPage = val.itemsPerPage
    },
    openCreate() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    }
  },
  watch: {
    'pagination.page'() {
      this.refresh()
    },
    'pagination.itemsPerPage'() {
      this.refresh()
    },
    query: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refresh()
        }
      }
    }
  },
  filters: {
    getStatus: item => {
      if (item.status === 'notSeen') {
        return 'Chưa duyệt'
      } else if (item.status === 'approved') {
        return 'Đã duyệt'
      } else if (item.status === 'hasResult') {
        return 'Đã có kết quả'
      } else {
        return '-'
      }
    },
    getDate: item => {
      if (item) return moment(item).format('DD/MM/YYYY')
      return ''
    }
  },
  components: { CreateReviewForm }
}
</script>
